import { createActionCreator } from 'utils';

const { createAction } = createActionCreator('Influencers');

export const setInfluencers = createAction('Set influencers');
export const fetchInfluencers = createAction(
  'Fetch influencers',
  (pageSize, pageNumber) => ({ pageSize, pageNumber, datasetName: 'influencer' })
);
export const createInfluencer = createAction('Create influencer');
export const deleteInfluencer = createAction('Delete influencer', (id) => ({ id }));
